var copyLink = {
    init: function () {
        var url = document.location.href;

        new ClipboardJS('[data-copy-link]', {
            text: function () {
                return url;
            },
        });
    },
};

export { copyLink };
